var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcoming"},[_c('div',{staticClass:"welcoming__container"},[_c('count-indicator',{attrs:{"content":_vm.content}})],1)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }